import React from 'react';
import { FormattedMessage } from 'react-intl';
import { array, string, number } from 'prop-types';
import Card from '../Card/Card';
import OfferLandingsTable from './OfferLandingsTable';
import PrelandersConstructorDisclaimer from '../Landings/PrelandersConstructorDisclaimer';
import { ThemedFMessage } from '../../hoc/IntlComponents';

const propTypes = {
  landings: array.isRequired,
  name: string,
  currency: string,
  topItem: number,
};

const defaultProps = {
  landings: [],
  name: 'landings',
};

const OfferLandings = ({ landings, name, currency, offer, site_key, connectOffer, topItem }) => {
  return (
    <div className="offer-card">
      <Card>
        <p className="offer-landings-title">
          <ThemedFMessage id={`offer.${name}.title`} />
        </p>

        {landings.length > 0 && (
          <OfferLandingsTable
            name={name}
            landings={landings}
            currency={currency}
            offer={offer}
            site_key={site_key}
            connectOffer={() => connectOffer(offer.id)}
            topItem={topItem}
          />
        )}

        {/* {name === 'prelanders' && (
        <Card.Footer>
          <PrelandersConstructorDisclaimer />
        </Card.Footer>
      )} */}
      </Card>
    </div>
  );
};

OfferLandings.propTypes = propTypes;
OfferLandings.defaultProps = defaultProps;

export default OfferLandings;
